
const issuerSearchColumns = () => {
  return [
    {
      Header: "Issuer ID",
      accessor: (data: any) => {
        return data.issuerId
      }
    },
    {
      Header: "Issuer Name",
      accessor: (data: any) => {
        return data.issuerName
      }
    },
    {
      Header: "Status",
      accessor: (data: any) => {
        return data.Status
      }
    }
  ]
}

export default issuerSearchColumns